var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"has-text-centered",attrs:{"title":_vm.display.title,"tabindex":"0"}},[_vm._v(_vm._s(_vm.display.horario))])
}
var staticRenderFns = []

export { render, staticRenderFns }